module.exports = __webpack_public_path__ + "img/psi.707a6bdb.png";